;(function ($) {

	'use strict';

	
	$('.btn--showMore').on('click', function(e) {
		var $articleContent = $(this).closest('.article__content, .collapse__content');

		if ($articleContent.length) {

			if ($articleContent.hasClass('active')) {
				$articleContent.removeClass('active');

				$(this).text($(this).attr('data-text-more'));

			}
			else {
				$articleContent.addClass('active');

				$(this).text($(this).attr('data-text-less'));
			}

		}
	});


})(jQuery);